/* TravelerPulse Specials — hand-crafted editorial features. Add new entries here. */
export const SPECIALS = [
  {
    slug: "kerala-ayurveda",
    to: "/articles/special/kerala-ayurveda",
    title: "Ayurveda in Kerala",
    subtitle: "A Living Tradition of Healing, Wellness and Medical Travel",
    heading: "Ayurveda in Kerala",
    place: "Kerala, India",
    guide: "/explore/india/kerala",
    blurb: "From Kottakkal's hospital wards to Ayur Diamond beach retreats — how to tell wellness Ayurveda from treatment Ayurveda, what the major therapies mean, and where to find them across all 14 districts.",
    accent: "from-emerald-900 to-lime-900",
  },
  {
    slug: "our-cochin",
    to: "/articles/special/our-cochin",
    title: "Kochi, Cochin, Ernakulam",
    subtitle: "A City of Three Names and a Thousand Stories",
    heading: "Our Cochin: The Kochi and Ernakulam We Remember",
    place: "Kerala, India",
    guide: "/explore/india/kerala/kochi",
    blurb: "Where pepper once sailed to distant empires, fishing nets rise against Arabian Sea sunsets, and a modern Metro glides above roads once ruled by Ambassadors and Royal Enfield Bullets.",
    accent: "from-emerald-800 to-teal-900",
  },
  {
    slug: "the-chenda",
    to: "/articles/special/the-chenda",
    title: "The Chenda Goes Global",
    subtitle: "Kerala's Thunderous Drum Finds a New Beat Across the World",
    heading: "The Chenda Goes Global",
    place: "Kerala, India",
    guide: "/explore/india/kerala",
    blurb: "From Thrissur Pooram's thunder to 500-plus drummers in the Pennsylvania Poconos — how Kerala's loudest tradition emigrated with the Malayalee and became a worldwide beat.",
    accent: "from-rose-900 to-amber-900",
  },
];
